
const ServiceRedirect = ({history, match: {params: {slug}}}) => {
  history.replace(`/listing/${slug}`);
};

export default ServiceRedirect;
